import { render, staticRenderFns } from "./ProductContentChaptersNotes.vue?vue&type=template&id=17ad98f2&scoped=true&"
import script from "./ProductContentChaptersNotes.vue?vue&type=script&lang=js&"
export * from "./ProductContentChaptersNotes.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentChaptersNotes.vue?vue&type=style&index=0&id=17ad98f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ad98f2",
  null
  
)

export default component.exports